/* eslint-disable no-useless-escape */

const addButtons = [
  {
    regex: /[\/]my-apis/i,
    label: 'ADD NEW API',
    pagePath: 'my-apis',
    actionPath: 'new',
    requiredRoles: [],
  },
  {
    regex: /[\/]my-apps/i,
    label: 'ADD NEW APP',
    pagePath: 'my-apps',
    actionPath: 'new',
    requiredRoles: [],
  },
  {
    regex: /[\/]my-articles/i,
    label: 'ADD NEW ARTICLE',
    pagePath: 'my-articles',
    actionPath: 'new',
    requiredRoles: [],
  },
  {
    regex: /[\/]my-team/i,
    label: 'ADD NEW TEAM MEMBER',
    pagePath: 'my-team',
    actionPath: '#invite',
    requiredRoles: ['OrganisationOwner'],
  },
  {
    regex: /[\/]my-directory/i,
    label: 'ADD NEW DIRECTORY ENTRY',
    pagePath: 'my-directory',
    actionPath: 'new',
    requiredRoles: [],
  },
  {
    regex: /[\/]my-data/i,
    label: 'ADD NEW CUSTOMER',
    pagePath: 'my-data',
    actionPath: '#new',
    requiredRoles: [],
  },
  {
    regex: /[\/]api-categories/i,
    label: 'ADD NEW API CATEGORY',
    pagePath: 'api-categories',
    actionPath: 'new',
    requiredRoles: [],
  },
  {
    regex: /[\/]app-categories/i,
    label: 'ADD NEW APP Features',
    pagePath: 'app-categories',
    actionPath: 'new',
    requiredRoles: [],
  },
  {
    regex: /[\/]my-services/i,
    label: 'ADD NEW SERVICE',
    pagePath: 'my-services',
    actionPath: 'new',
    requiredRoles: [],
  },
  {
    regex: /[\/]service-categories/i,
    label: 'ADD NEW SERVICE CATEGORY',
    pagePath: 'service-categories',
    actionPath: 'new',
    requiredRoles: [],
  },
];

export { addButtons };
